import React, { useContext } from 'react';
import { PiDotsThreeOutlineVertical } from 'react-icons/pi';
import ModalContainer from '../ModalContainer';
import cardIcon from '../../assets/feeda-icon.svg';
import UploadFileModal from '../UploadFileModal';
import sessionsService from '../../services/sessionsServices';
import { TemporaryChatContext } from '../../Context/temporaryChatContext';
import { useNavigate } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import { TeamCardStyled, ReponseMenu, MenuBtn, StyleItem } from './TeamCard.styles';
import DeleteTeamModal from '../DeleteTeamModal';
import CreatTeamModal from '../CreatTeamModal';

const TeamCard = ({
  teamCardsData,
  removeDelete = false,
  removeDuplicate = false,
  aiAgents = true,
  refetch,
  filterName,
  setSuccessModal,
}) => {
  const { setChatmessages, updateAgent, setSessionAgent } = useContext(TemporaryChatContext);
  const { user } = useContextHook(AuthContext, v => ({
    user: v.user,
  }));
  const navigate = useNavigate();
  const chatWithAgent = async agentObj => {
    updateAgent(agentObj);
    setSessionAgent(agentObj);
    setChatmessages([]);
    const sessionRes = await sessionsService.createSession({
      user_id: user?.data?.ID,
      platform_id: 'feedalabs',
      agent_id: agentObj?.value,
      project_id: 'test',
      mode: 'team',
    });
    navigate(`/chat/${sessionRes?.session_id}`);
  };

  function getImageSrc(base64String, fallback) {
    if (!base64String) return fallback;
    if (base64String.startsWith('data:image')) {
      return base64String;
    }
    return fallback;
  }
  return (
    <>
      {teamCardsData
        ?.filter(card => {
          if (!filterName) return true;
          return card.team_name.toLowerCase().includes(filterName.toLowerCase());
        })
        ?.map(card => (
          <TeamCardStyled key={card.team_id}>
            <div className="card-header">
              <div className="img-box">
                <img src={getImageSrc(card?.icon, cardIcon)} alt="img" />
              </div>
              <ReponseMenu
                menuButton={
                  <MenuBtn>
                    <PiDotsThreeOutlineVertical size="22" />
                  </MenuBtn>
                }>
                {removeDelete !== false && (
                  <ModalContainer
                    width="600"
                    title="Confirm Team Deletion"
                    content={({ onClose }) => (
                      <DeleteTeamModal onClose={onClose} _id={card?.team_id} refetch={refetch} />
                    )}
                    btnComponent={({ onClick }) => (
                      <StyleItem onClick={onClick}>
                        <div className="text" style={{ color: 'var(--danger)' }}>
                          Delete Team
                        </div>
                      </StyleItem>
                    )}
                  />
                )}
                {removeDelete !== false && (
                  <ModalContainer
                    width="1000"
                    title="Edit Team"
                    content={({ onClose }) => <CreatTeamModal onClose={onClose} refetch={refetch} isEdit={card} />}
                    btnComponent={({ onClick }) => (
                      <StyleItem onClick={onClick}>
                        <div className="text">Edit Team</div>
                      </StyleItem>
                    )}
                  />
                )}

                {removeDuplicate === false && (
                  <ModalContainer
                    width="1000"
                    title="Create Team"
                    content={({ onClose }) => (
                      <CreatTeamModal
                        onClose={onClose}
                        refetch={refetch}
                        isEdit={card}
                        setSuccessModal={setSuccessModal}
                        isDuplicate
                      />
                    )}
                    btnComponent={({ onClick }) => (
                      <StyleItem onClick={onClick}>
                        <div className="text">Duplicate Team</div>
                      </StyleItem>
                    )}
                  />
                )}

                <StyleItem
                  onClick={() =>
                    chatWithAgent({
                      label: card?.team_name,
                      value: card?.team_id,
                      icon: card?.icon,
                      mode: 'team',
                    })
                  }>
                  <div className="text">Chat</div>
                </StyleItem>
                {removeDelete !== false && (
                  <ModalContainer
                    noHead
                    width="1150"
                    btnComponent={({ onClick }) => (
                      <StyleItem onClick={onClick}>
                        <div className="text">Attach documents</div>
                      </StyleItem>
                    )}
                    content={({ onClose }) => <UploadFileModal onClose={onClose} seprateUpdateID={card?.id} />}
                  />
                )}
              </ReponseMenu>
            </div>
            <div className="text-box">
              <strong className="title">{card.team_name}</strong>
              <p>{card.description}</p>
            </div>
            {aiAgents && (
              <div className="card-footer">
                <div className="name">{card.creatorInitial}</div>
                <span className="created">Created by Feeda</span>
                {/* <span className="created">Created by {card.createdBy}</span> */}
              </div>
            )}
          </TeamCardStyled>
        ))}
    </>
  );
};

export default TeamCard;
